import * as StorageService from '../../services/StorageService';

export const getToken = (beforeToken = null) => {
	if(beforeToken !== undefined && beforeToken) return beforeToken;
	const token = StorageService.getToken();
	if(token === undefined) return null;
	return token;
};
